import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {DiversityDemographicData} from '../../../../model';
import {PopperContent} from 'ngx-popper';
import {TranslateService} from '@ngx-translate/core';
import {DiversityInsightService} from '../service/diversity-insight.service';

@Component({
  selector: 'horizontal-bar-graph',
  templateUrl: './horizontal-bar-graph.component.html',
  styleUrls: ['./horizontal-bar-graph.component.scss']
})
export class HorizontalBarGraphComponent {

  @Input() chartData: DiversityDemographicData[] = [];
  @Input() quarter: string;
  @Input() numberOfOrders: number;
  @Input() notEnoughDataMessage: string;
  @Input() notEnoughDataMessageSubText: string;
  @Input() entireNotEnoughData: boolean;
  @Output() selectedFunnelStage = new EventEmitter<string>();

  @ViewChild('popperContent') popper: PopperContent;

  popperContentValue: string;

  constructor(private Translate: TranslateService,
              private diversityInsightService: DiversityInsightService) {}

  stageClicked(chartRow: DiversityDemographicData) {
    // stage comes in with the count in parens like this: submitted (42)
    // that's why I need to split
    if (chartRow.data[0].notEnoughData !== true) {
      this.selectedFunnelStage.emit(chartRow.label.split(' ', 1)[0]);
    }
  }

  updatePopperContent(content: string) {
    this.popperContentValue = content;
  }

  isGraphRowShown(chartLabel) {
    return this.diversityInsightService.getStageDisplayStatus(chartLabel);
  }

  isDemographicShown(demographicLabel) {
    return this.diversityInsightService.getDemographicDisplayStatus(demographicLabel);
  }
}
